import VueCookies from 'vue-cookies';
import ApiService from '@/core/api/api.service';
import TokenService from '@/core/api/token.service';
import store from '@/store';

import { functionsWithNotifications } from '@/core/notifications';
import userMessages from './user.messages';

const functions = {
  getUser,
  requestEmailVerification,
  clearCache,
};

export default {
  ...functionsWithNotifications(functions, userMessages),
};

const userApi = new ApiService({
  baseUrl: store.getters.umBaseUrl,
});
userApi.extendBaseUrl('/me');

async function getUser() {
  try {
    const response = await userApi.get();
    const { user } = response.data;
    store.commit('setUser', user);
    return user;
  } catch (error) {
    if (_.get(error, 'response.status') === 401) {
      TokenService.removeAuthToken();
      store.commit('resetUser');
    }
    throw error;
  }
}

/**
 * Requests an email verification for a user that registered via the sign up page (the verification link is provided via an email).
 * To prevent users spamming the resend email link and sending multiple emails in a short space of time, a cookie is generated for the user the email verification is requested for.
 * If there is already a cookie for the user, the email verification request will not be sent again.
 *
 * @param {string} userUuid The uuid of the user to request an email verification for
 * @param {object} params Optional arbitrary params object whose properties will be appended to the verification link URL as is, in the form of ?key=value query params
 * @return {Object} The user data of user that the email verification is requested for
 */
async function requestEmailVerification(userUuid, params = {}) {
  // Cookie name includes the user's uuid to make it unique to that user
  const emailVerificationRequestName = `email_verification_request_${userUuid}`;
  const expiry = '2min';

  if (VueCookies.get(emailVerificationRequestName)) {
    return;
  }

  await userApi.put('confirm', null, { params });
  VueCookies.set(emailVerificationRequestName, emailVerificationRequestName, expiry);
}

async function clearCache() {
  userApi.clearCache();
  store.commit('resetUser');
}
